import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "./pages/LandingPage";
import Auth from "./pages/Auth";
import SuperAdminDashboard from "./pages/SuperAdminDashboard";
import SchoolAdminDashboard from "./pages/SchoolAdminDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import TeacherDashboard from "./pages/TeacherDashboard";
import CreateExam from "./pages/CreateExam";
import StudentDashboard from "./pages/StudentDashboard";
import TakeExam from "./pages/TakeExam";
import Submissions from "./pages/Submissions";
import GradeSubmission from "./pages/GradeSubmission";
import ViewGradedPaper from "./pages/ViewGradedPaper";
import ManageSettings from "./pages/ManageSettings";
import DataEntryDashboard from "./pages/DataEntryDashboard";
import SubjectConfiguration from "./pages/SubjectConfiguration";
import StudentProgressReport from "./pages/StudentProgressReport";
import StudentAnalyticsDashboard from "./pages/StudentAnalyticsDashboard";
import AssessmentConfiguration from "./pages/AssessmentConfiguration";
import BulkImport from "./pages/BulkImport";
import QuestionBankDashboard from "./pages/QuestionBankDashboard";
import QuestionEditor from "./pages/QuestionEditor";
import PapersManagement from "./pages/PapersManagement";
import TopicsManagement from "./pages/TopicsManagement";
import QBMBulkImport from "./pages/QBMBulkImport";
import QBMAnalytics from "./pages/QBMAnalytics";
import TeacherAnalyticsDashboard from "./pages/TeacherAnalyticsDashboard";
import PDFImportWizard from "./pages/PDFImportWizard";
import SchoolQuestionBank from "./pages/SchoolQuestionBank";
import AIGradingReview from "./pages/AIGradingReview";
import CMSEditor from "./pages/CMSEditor";
import LTISetup from "./pages/LTISetup";
import LTISelectExam from "./pages/LTISelectExam";
import LTIExamTake from "./pages/LTIExamTake";
import ContactUs from "./pages/ContactUs";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import LegalPagesEditor from "./pages/LegalPagesEditor";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import BlogAdmin from "./pages/BlogAdmin";
import BlogPostEditor from "./pages/BlogPostEditor";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/login" element={<Auth />} />
          <Route path="/super-admin/dashboard" element={<SuperAdminDashboard />} />
          <Route path="/super-admin/cms" element={<CMSEditor />} />
          <Route path="/super-admin/lti" element={<LTISetup />} />
          <Route path="/super-admin/legal" element={<LegalPagesEditor />} />
          <Route path="/super-admin/blog" element={<BlogAdmin />} />
          <Route path="/super-admin/blog/new" element={<BlogPostEditor />} />
          <Route path="/super-admin/blog/edit/:id" element={<BlogPostEditor />} />
          <Route path="/school-admin/dashboard" element={<SchoolAdminDashboard />} />
          <Route path="/school-admin/subjects" element={<SubjectConfiguration />} />
          <Route path="/school-admin/progress-reports" element={<StudentProgressReport />} />
          <Route path="/school-admin/student-analytics" element={<StudentAnalyticsDashboard />} />
          <Route path="/school-admin/assessments" element={<AssessmentConfiguration />} />
          <Route path="/school-admin/bulk-import" element={<BulkImport />} />
          <Route path="/school-admin/question-bank" element={<SchoolQuestionBank />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
          <Route path="/teacher/create-exam" element={<CreateExam />} />
          <Route path="/teacher/edit-exam/:examId" element={<CreateExam />} />
          <Route path="/teacher/settings" element={<ManageSettings />} />
          <Route path="/teacher/submissions/:examId" element={<Submissions />} />
          <Route path="/teacher/grade/:submissionId" element={<GradeSubmission />} />
          <Route path="/teacher/subjects" element={<SubjectConfiguration />} />
          <Route path="/teacher/progress-reports" element={<StudentProgressReport />} />
          <Route path="/teacher/student-analytics" element={<StudentAnalyticsDashboard />} />
          <Route path="/teacher/assessments" element={<AssessmentConfiguration />} />
          <Route path="/teacher/bulk-import" element={<BulkImport />} />
          <Route path="/teacher/analytics" element={<TeacherAnalyticsDashboard />} />
          <Route path="/teacher/analytics/:examId" element={<TeacherAnalyticsDashboard />} />
          <Route path="/teacher/question-bank" element={<SchoolQuestionBank />} />
          <Route path="/teacher/ai-grading/:submissionId" element={<AIGradingReview />} />
          <Route path="/data-entry/dashboard" element={<DataEntryDashboard />} />
          <Route path="/data-entry/create-exam" element={<CreateExam />} />
          <Route path="/data-entry/edit-exam/:examId" element={<CreateExam />} />
          {/* Question Bank Manager Routes */}
          <Route path="/qbm/dashboard" element={<QuestionBankDashboard />} />
          <Route path="/qbm/question/new" element={<QuestionEditor />} />
          <Route path="/qbm/question/:questionId" element={<QuestionEditor />} />
          <Route path="/qbm/question/:questionId/edit" element={<QuestionEditor />} />
          <Route path="/qbm/papers" element={<PapersManagement />} />
          <Route path="/qbm/topics" element={<TopicsManagement />} />
          <Route path="/qbm/import" element={<QBMBulkImport />} />
          <Route path="/qbm/pdf-import" element={<PDFImportWizard />} />
          <Route path="/qbm/analytics" element={<QBMAnalytics />} />
          <Route path="/student/dashboard" element={<StudentDashboard />} />
          <Route path="/student/exam/:examId" element={<TakeExam />} />
          <Route path="/student/graded/:submissionId" element={<ViewGradedPaper />} />
          {/* LTI Routes */}
          <Route path="/lti/select-exam" element={<LTISelectExam />} />
          <Route path="/lti/exam/:examId" element={<LTIExamTake />} />
          <Route path="/lti/dashboard" element={<TeacherDashboard />} />
          <Route path="/lti/student" element={<StudentDashboard />} />
          {/* Blog Author Routes */}
          <Route path="/blog-author/dashboard" element={<BlogAdmin />} />
          <Route path="/blog-author/posts/new" element={<BlogPostEditor />} />
          <Route path="/blog-author/posts/edit/:id" element={<BlogPostEditor />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
